import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';
import { Client } from '../interfaces/clients';
import { ComplexRequest } from '../interfaces/complexrequest';
@Injectable({
  providedIn: 'root',
})
export class ComplexService {
  constructor(private http: HttpClient) { }
  getById(id: number): Observable<ComplexRequest> {
    return this.http.get<ComplexRequest>(`${environment.Server_URL}/complex-requests/${id}`);
  }
  create(complexrequests: FormData): Observable<ComplexRequest> {
    return this.http.post<ComplexRequest>(`${environment.Server_URL}/complex-requests`, complexrequests);
  }
update(id: number, payload: any): Observable<any> {
  return this.http.patch(
    `${environment.Server_URL}/complex-requests/${id}`,
    payload,
    { headers: { 'Content-Type': 'application/json' } }
  );
}
updateCustom(id: number, payload: any): Observable<any> {
  const isFormData = payload instanceof FormData;

  return this.http.post(
    `${environment.Server_URL}/complex-requests/update/${id}`,
    payload,
    isFormData ? {} : { headers: { 'Content-Type': 'application/json' } }
  );
}

  // client.service.ts
  updateStatus(id: number, status: number) {
    return this.http.patch<any>(`${environment.Server_URL}/complex-requests/${id}/status`, { status });
  }

  delete(id: number): Observable<any> {
    return this.http.delete(`${environment.Server_URL}/complex-requests/${id}`);
  }
  getAll(perpage: number, page: number): Observable<any> {
    return this.http.get<any>(`${environment.Server_URL}/complex-requests?per_page=${perpage}&page=${page}`);
  }
   searchClients(serachkey: any): Observable<any> {
      const params = new HttpParams().set('q', serachkey);
     return this.http.get(`${environment.Server_URL}/complex-requests/search`, { params });
   }

   searchComplex(q: string, page = 1): Observable<any> {
    let params = new HttpParams().set('q', q).set('page', page);
    return this.http.get(`${environment.Server_URL}/complex-requests/search`, { params });
  }
}
